const getters = {
  getAll (state) {
    return state.all
  },
  getItemById: (state) => (id) => {
    return state.all.find(item => item.id === id)
  },
  getItemByProperty: (state) => (property, value) => {
    return state.all.find(item => item[property] === value)
  }
}

const actions = {
}

const mutations = {
  init (state, set, Model) {
    state.all = []
    for (let item of set) {
      state.all.push(new Model(item))
    }
  },
  setCurrent (state, item) {
    state.current = item
  },
  unsetCurrent (state) {
    state.current = null
  },
  create (state, item, Model) {
    state.all.push(new Model(item))
  },
  update (state, item, Model) {

  },
  updatePropertyOfItem (state, item, property, value) {
    let newState = []
    for (let thisItem of state.all) {
      if (thisItem.id === item.id) {
        thisItem[property] = value
        newState.push(thisItem)
      } else {
        newState.push(thisItem)
      }
    }
    state.all = newState
  },
  delete (state, item) {
    state.all = state.all.filter(function (thisItem) {
      return thisItem._id !== item._id
    })
  },
  setProperty (state, payload) {
    state[payload.property] = payload.value
  }
}

export default {
  getters,
  actions,
  mutations
}
